import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import backend from "i18next-xhr-backend";
import { initReactI18next } from "react-i18next";
const availableLanguages = ['en', 'en-US', 'es', 'es-DO', 'fr', 'ar', 'ar-SA'];
// require('dotenv').config();
const userLang =  window?.psh_configs?.selectedLanguage;
const defaultLocale = userLang?.substring(0, 2);
const resources = {
}; 

const options = {
  // order and from where user language should be detected
  order: [ 'navigator', 'htmlTag', 'path', 'subdomain'],

  // // keys or params to lookup language from
  // lookupQuerystring: 'lng',
  // lookupCookie: 'i18next',
  // lookupLocalStorage: 'i18nextLng',
  // lookupFromPathIndex: 0,
  // lookupFromSubdomainIndex: 0,

  // cache user language on
  // caches: ['localStorage', 'cookie'],
  // excludeCacheFor: ['cimode'], // languages to not persist (cookie, localStorage)

  // // optional expire and domain for set cookie
  // cookieMinutes: 10,
  // cookieDomain: 'myDomain',

  // // optional htmlTag with lang attribute, the default is:
  // htmlTag: document.documentElement,

  // only detect languages that are in the whitelist
  // interpolation: {
  //   escapeValue: false, // not needed for react!!
  // },
  resources,
  whitelist : availableLanguages,
  debug: true,
  fallbackLng: 'en',
  ns: ['common'],
  defaultNS: 'common',
  react: {
    wait: false,
    bindI18n: 'languageChanged loaded',
    bindStore: 'added removed',
    nsMode: 'default'
  }
}

i18n
    .use(detector)
    .use(backend)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
      lng: defaultLocale,
      fallbackLng: "en", // use en if detected lng is not available
      whitelist: availableLanguages,
      detection: options,
      keySeparator: false, // we do not use keys in form messages.welcome
      backend: {
        // for all available options read the backend's repository readme file
        // loadPath: PUBLIC_URL+'/locales/{{lng}}/constants.json'
        loadPath: `${process.env.REACT_APP_PUBLIC_URL}/locales/{{lng}}/{{ns}}/constants.json`
      },
      interpolation: {
        escapeValue: false // react already safes from xss
      }
    });
     
  

export default i18n;